{
  "documentOrder": ["til", "bapn"],
  "termsPurchase": {
    "uplift": {
      "terms": "<div><span>By clicking \"I agree and continue\", I confirm that I have reviewed and electronically agree to the <i>Truth in Lending Disclosure</i>{{docName}}<i>Borrower Agreement & Promissory Note</i><automaticPayments/></span><csdTerms/><span><strong>Uplift does NOT place a hard credit inquiry.</strong></span></div>"
    },
    "flexpay": {
      "terms": "<div><span>By clicking \"I agree and continue\", I confirm that I have reviewed and electronically agree to the <i>Truth in Lending Disclosure</i> and{{docName}}<i>Borrower Agreement & Promissory Note</i><automaticPayments/></span><csdTerms/><span>We <strong>do not</strong> place a hard credit inquiry.</span></div>"
    },
    "csd": "Credit Score Disclosure"
  },
  "addCsdTerms": "<span>I have received the <termsLink/><wisconsinLink> and Wisconsin Disclosure</wisconsinLink>. </span>",
  "addAutomaticPayments": "<span><text/><i><title/></i></span>",
  "docName": {
    "ach": ", the ",
    "dcd": ", the ",
    "default": " and the "
  },
  "submit": "I Agree and Continue"
}
